import { Link } from "react-router-dom";
import { ChromeHeading, GoldText, GoldButton, OutlineGoldButton, Section } from "../funnel";
import { ReplayVideo } from "./ReplayVideo";
import { scrollToId } from "../../lib/scroll";

export const ReplayHero = () => (
  <section className="relative overflow-hidden" data-testid="replay-hero-section">
    <div className="breathe-glow pointer-events-none absolute left-1/2 top-10 h-[620px] w-[min(1100px,140vw)] -translate-x-1/2" aria-hidden="true" />
    <div className="gutter relative flex flex-col items-center pb-20 pt-12 text-center sm:pt-16">
      <p className="font-mono-plex fade-up text-[11px] tracking-[0.2em] text-[var(--gold)] sm:text-[12px] sm:tracking-[0.28em]" data-testid="replay-hero-eyebrow">WEAPONIZED CREDIT TO CAPITAL · REPLAY</p>
      <ChromeHeading as="h1" className="fade-up mt-5 max-w-4xl text-[42px] [animation-delay:100ms] sm:text-6xl lg:text-7xl" data-testid="replay-hero-headline">
        Information was never the problem. <GoldText>Process and accountability were.</GoldText>
      </ChromeHeading>
      <div className="fade-up mt-10 w-full max-w-4xl [animation-delay:200ms]">
        <ReplayVideo />
      </div>
      <div className="fade-up mt-9 flex w-full flex-col items-center gap-3 [animation-delay:300ms] sm:w-auto sm:flex-row sm:gap-4">
        <GoldButton size="lg" pulse onClick={() => scrollToId("enroll")} className="w-full sm:w-auto" data-testid="replay-hero-enroll-button">I'M READY, ENROLL ME</GoldButton>
        <OutlineGoldButton as={Link} to="/apply" className="w-full px-8 py-4 sm:w-auto" data-testid="replay-hero-talk-button">Talk to the team first</OutlineGoldButton>
      </div>
    </div>
  </section>
);

export const Stall = () => (
  <Section data-testid="stall-section">
    <div className="mx-auto max-w-3xl">
      <ChromeHeading className="text-4xl sm:text-5xl lg:text-6xl">You could run it yourself. Here's where most people stall.</ChromeHeading>
      <p className="mt-8 text-[17px] leading-relaxed text-[#cfc7b6]">They know enough to be dangerous. They dispute a few items, apply once, get a denial they don't understand, and quietly stop.</p>
      <p className="mt-5 text-[17px] leading-relaxed text-[#cfc7b6]">Not because they couldn't do it, but because nobody was checking their file, telling them the next move, or holding them to it.</p>
      <p className="gold-text mt-8 text-2xl font-semibold leading-snug sm:text-3xl">Educate II Elevate is where you stop guessing.</p>
    </div>
  </Section>
);
